import {ApolloProvider} from "@apollo/client";
import {FC, useMemo} from "react";
import {createApolloClient} from "./graphql/apolloClient";

type Props = {
    children: any
}

const getNoToken = async () => undefined;

export const PublicConnectionProvider: FC<Props> = ({children}) => {
    const client = useMemo(() => (
        createApolloClient(getNoToken, getNoToken)
    ), []);

    return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default PublicConnectionProvider;
